import { Button, Flex, SideBySideLayout, Text } from 'mds-web-ui'

import { DocumentTitle } from '@/utils/DocumentTitle'
import { ActiveLink } from '@/utils/Link'

export const ErrorPage = () => {
  const onReloadClicked = () => {
    window.location.reload()
  }

  return (
    <>
      <DocumentTitle title="Something went wrong! | Flow by Bonobo" />
      <SideBySideLayout showFooter currentSite={null} LinkComponent={ActiveLink}>
        <Flex alignItems="center" flexDirection="column">
          <Text fontSize={5} mt={5} mb={3} color="grayapptitle">
            Something went wrong! We&apos;ve been notified and will fix it as soon as possible.
          </Text>
          <Button color="black" type="primary" onClick={onReloadClicked} mt={3} uppercase>
            Reload the page
          </Button>
        </Flex>
      </SideBySideLayout>
    </>
  )
}
